<div class="p-img-box">
    <dl>
        <dt>
            <img src="{{DataUrl}}">
        </dt>
        <dd>
            <ul>
                <li class="nickName">{{NickName}}</li>
                <li class="meterNo">考米号：{{MeterNo}}</li>
                <li class="nav clearfix">
                    <a class="fl" href="./home.html?userid={{UserID}}">查看我的主页</a>
                    <i class="iconfont icon-gengduo-right fl"></i>
                </li>
            </ul>
        </dd>
    </dl>
    <div class="p-flow-box clearfix">
        <div class="fl" id="pattentionList" style="width:70px">
            <h2>{{AttentionCount}}</h2>
            <h4>关注</h4>
        </div>
        <div class="fl" id="pfollowList" style="width:114px">
            <h2>{{FansCount}}</h2>
            <h4>粉丝</h4>
        </div>
        <div class="fl" id="pvistorList" style="width:70px">
            <h2>{{VisitorCount}}</h2>
            <h4>访客</h4>
        </div>
    </div>
</div>
<div class="p-nav-box">
    <a href="?type=account" class="clearfix">
        <span class="fl">我的账户</span>
        {{if TotalCanUseCash}}
            <h5 class="fr" style="color:#FF5379">{{TotalCanUseCash}}声币</h5>
        {{/if}}
    </a>
    <a href="?type=point" class="clearfix">
        <span class="fl">我的积分</span>
        {{if CanUseScore}}
            <h5 class="fr" style="color:#E15FFF">{{CanUseScore}}积分</h5>
        {{/if}}
    </a>
    <a href="?type=data">
        <span>我的资料</span>
    </a>
    <a href="?type=record">
        <span>语聊记录</span>
    </a>
    {{if RoleID == 2 || RoleID == 4 || RoleID == 7}}
        <a href="?type=manage">
            <span>入驻管理</span>
        </a>
    {{else}}
        <a href="?type=apply">
            <span>申请入驻</span>
        </a>
    {{/if}}
    
    <a href="?type=setting">
        <span>设置</span>
    </a>
    
</div>